import { render, staticRenderFns } from "./ValidacionExtendidaForm.vue?vue&type=template&id=edcf3860&"
import script from "./ValidacionExtendidaForm.vue?vue&type=script&lang=ts&"
export * from "./ValidacionExtendidaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports